import { Controller } from "@hotwired/stimulus";
import { visit } from "@hotwired/turbo"
import { editAdminStorePickupPointPath } from "src/routes";

export default class extends Controller {
  static targets = ["addressInput", "addressModalFrame", "activePickupPointIdField"];

  declare storeAvailabilitiesTaget : HTMLButtonElement;
  declare addressInputTarget: HTMLInputElement;
  declare addressModalFrameTarget: HTMLElement;
  declare activePickupPointIdFieldTarget: HTMLInputElement;

  openAddressModal(): void {
    this.addressInputTarget.blur();

    visit(
      editAdminStorePickupPointPath(this.data.get("store-id")!, this.activePickupPointIdFieldTarget.value || "0"),
      { frame: this.addressModalFrameTarget.id }
    );
  }

  closeAddressModal(): void {
    this.addressModalFrameTarget.innerHTML = '';
  }

  setPickupPoint(id: number, address: string): void {
    this.activePickupPointIdFieldTarget.value = id.toString();
    this.addressInputTarget.value = address;
    this.closeAddressModal();
  }
}
